// Helpers to normalize API responses from backend which sometimes return
// { success: true, data: { ... } } and sometimes raw arrays/objects.
export function unwrapApi(response) {
  if (response == null) return null;
  // If axios-like object with data property holding the useful payload
  if (typeof response === 'object') {
    if ('success' in response && 'data' in response) return response.data;
    if ('data' in response) return response.data;
  }
  return response;
}

// Try to extract an array from common locations: response (itself), response.meetings,
// response.data (already unwrapped), response.items, etc.
export function extractArray(resp, ...possibleKeys) {
  if (!resp) return [];
  if (Array.isArray(resp)) return resp;
  // common keys to fallback to
  const keys = possibleKeys.length ? possibleKeys : ['meetings', 'data', 'items', 'rows', 'results'];
  for (const k of keys) {
    const v = resp[k];
    if (Array.isArray(v)) return v;
  }
  // If resp has a nested data that is an object with arrays inside
  for (const key of Object.keys(resp)) {
    if (Array.isArray(resp[key])) return resp[key];
  }
  return [];
}

export default { unwrapApi, extractArray };
